module.exports = "#options-menu\r\n{\r\n    border:1px solid #337ab7;color:#337ab7;\r\n}\r\n\r\n#options-menu a{\r\n    color:#337ab7;\r\n}\r\n\r\n.ui-dialog-footer .ui-widget-content \r\n{\r\n    border:none;\r\n    margin-top:50px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reportdashboard/reportlisting/reportlisting.component.css
// module id = ./src/app/reportdashboard/reportlisting/reportlisting.component.css
// module chunks = main